import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import NewItemsPage from ".";

whenDomReady(() => {
  if (document.querySelector('[data-hypernova-key="NewItemsPage"]')) {
    renderFromPreloadedJSON(NewItemsPage, "NewItemsPage");
  }
});
